import { goalsEnTranslations } from './goals.en';
import { goalsHeTranslations } from './goals.he';

export const goalsTranslations = {
  en: goalsEnTranslations,
  he: goalsHeTranslations,
} as const;
